// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { BaseButton, Button } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { memoizeFunction } from "@fluentui/react";

/**
 * Common onMenuClick callback used to prevent the opening of menus when we want to appear interactive, but menu code isn't ready yet.
 */
export const getPreventMenuClickCallback = memoizeFunction(
  (executionLogger?: () => void) => {
    return (
      ev?:
        | React.MouseEvent<HTMLElement | BaseButton | Button>
        | React.KeyboardEvent<HTMLElement | BaseButton | Button>
    ) => {
      ev?.preventDefault();
      executionLogger?.();
    };
  }
);
